import { PageType } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { tracking } from "scmp-app/data";
import type { haHaHappeningsQuery$key } from "scmp-app/queries/__generated__/haHaHappeningsQuery.graphql";

import { Container, Content, StyledContentItemPostiesPrimary, StyledHeadline } from "./styles";

type Props = {
  className?: string;
  reference: haHaHappeningsQuery$key;
};

export const HaHaHappenings: FunctionComponent<Props> = ({ className, reference: reference_ }) => {
  const data = useFragment(
    graphql`
      fragment haHaHappeningsQuery on Query {
        haHaHappeningsSection: section(filter: { entityId: "515469" }) {
          ...headlineSection
        }
        haHaHappeningsQueue: queue(filter: { name: "section_top_515469" }) {
          items(first: 1) {
            edges {
              node {
                ... on Article {
                  ...postiesPrimaryContentItemContent
                }
              }
            }
          }
        }
      }
    `,
    reference_,
  );

  const customQueryParameters = {
    module: tracking.module.HaHaHappenings,
    pgtype: tracking.pageType.Content,
  };

  return (
    <Container className={className}>
      <StyledHeadline
        color="#FF7C1D"
        query={{
          pageType: PageType.PostiesSection,
          ...customQueryParameters,
        }}
        reference={data.haHaHappeningsSection}
      />
      <Content>
        {data?.haHaHappeningsQueue?.items?.edges?.map((edge, index) => (
          <StyledContentItemPostiesPrimary
            customQueryParameters={{
              pageType: PageType.PostiesArticle,
              ...customQueryParameters,
            }}
            key={index}
            reference={edge.node}
          />
        ))}
      </Content>
    </Container>
  );
};

HaHaHappenings.displayName = "HaHaHappenings";
